import { NavController, NavParams } from '@ionic/angular';
import { Router, ActivatedRoute } from '@angular/router';

/**
 * Le pagine possono derivare da qui per avere alcuni metodi di utility
 */
export abstract class AbstractPage {

    constructor(
        protected navCtrl: NavController,
        protected router: Router) {
    }

    // https://stackoverflow.com/questions/51828017/navcontroller-doesnt-work-in-ionic-4
    /**
     * naviga alla pagina passata come parametro
     */
    protected goto(pagina: string) {
        console.log(`go to pagina ${pagina}`);
        this.navCtrl.navigateForward(pagina).then(res => {
            if (!res) {
               this.navCtrl.navigateRoot('auth');
            }
        });
    }
}
